<template>
  <v-container>
    <back-button :label="trans('survey.surveys')"></back-button>
    <page-heading>{{ pageTitle }}</page-heading>

    <request-state :retry-action="loadQuestions" :request-promise="questionPromise">
      <v-row>
        <v-col :cols="colsEditQuestions" class="pb-0">
          <div class="d-flex justify-space-between">
            <div class="text-h6 mb-5">{{ transPlural('survey.question.question') }}</div>
            <save-button @click="saveQuestions" :loading="savingQuestions"></save-button>
          </div>
        </v-col>
        <v-col :cols="colsPreview" class="pb-0">
          <div class="text-h6 text-center mb-5"><v-icon left>mdi-magnify</v-icon>{{ trans('survey.question.preview') }}</div>
        </v-col>
      </v-row>

      <draggable
        v-model="questions"
        group="survey-questions"
        handle=".drag-handle"
        animation="100"
      >
        <v-row v-for="(question, i) in questions" :key="i">
          <v-col :cols="colsEditQuestions">
            <survey-question
              :question="question"
              :number="i+1"
              @delete="onQuestionDelete(question)"
              :validation-errors="validationFieldErrors && validationFieldErrors.questions ? validationFieldErrors.questions[i] : null"
              class="mb-4"
            >
              <template v-if="tmpEditMode" #drag-handle-question>
                <drag-handle />
              </template>
            </survey-question>
          </v-col>
          <v-col :cols="colsPreview">
            <survey-result-answer class="mb-4" :question="question" :number="i+1" />
          </v-col>
        </v-row>
      </draggable>

      <v-row>
        <v-col :cols="colsEditQuestions">
          <div class="d-flex justify-space-between">
            <v-btn @click="addQuestion" color="primary">
              <v-icon left>mdi-plus</v-icon>
              {{ trans('survey.question.add') }}
            </v-btn>
            <save-button @click="saveQuestions" :loading="savingQuestions"></save-button>
          </div>
        </v-col>
      </v-row>

    </request-state>
  </v-container>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils';
import PageHeading from '../components/PageHeading';
import {RouterUtils} from '../utils/router-utils';
import {MainUtils} from '@/utils/main-utils';
import {SurveyApi} from '@/api/survey-api';
import RequestState from '../components/RequestState';
import SurveyQuestion from '../components/survey/SurveyQuestion';
import {SurveyQuestionTypes} from '@/lib/survey-question-types';
import {SurveyQuestionDisplayTypes} from '@/lib/survey-question-display-types';
import SaveButton from '@/components/SaveButton';
import draggable from 'vuedraggable'
import DragHandle from '@/components/DragHandle';
import SurveyResultAnswer from '@/components/survey/SurveyResultAnswer';
import BackButton from '@/components/BackButton';

export default {
  name: 'SurveyQuestionsPage',
  mixins: [
    LocaleUtils,
    RouterUtils,
    MainUtils
  ],
  components: {
    BackButton,
    SurveyResultAnswer,
    DragHandle,
    SaveButton,
    SurveyQuestion,
    RequestState,
    PageHeading,
    draggable
  },
  data: () => ({
    tmpEditMode: true,
    questions: null,
    questionPromise: null,
    colsEditQuestions: 7,
    colsPreview: 5,
    savingQuestions: false
  }),
  computed: {
    pageTitle () {
      return this.trans('survey.edit');
    }
  },
  mounted() {
    this.loadQuestions();
  },
  methods: {
    loadQuestions() {
      this.questionPromise = SurveyApi.getAllQuestions();
      this.questionPromise.then(value => {
        this.questions = value.body.content;
      })
      .catch(error => {
        this.questions = [];
      })
    },
    addQuestion () {
      this.questions.push({
        type: SurveyQuestionTypes.MULTIPLE_CHOICE_SINGLE,
        text: null,
        order: 0,
        displayType: SurveyQuestionDisplayTypes.VERTICAL,
        surveyAnswers: [
          {
            text: 'Option 1',
            order: 0
          }
        ]
      });
    },
    saveQuestions () {
      this.savingQuestions = true;
      SurveyApi.updateAllQuestions({questions: this.questions})
        .then((response) => {
          this.showSavedSuccessfullyNotification(response);
          this.validationErrors = {};
          this.loadQuestions();
        })
        .catch((response) => this.validationErrors = this.getValidationErrors(response))
      .finally(() => this.savingQuestions = false)
      ;
    },
    onQuestionDelete (question) {
      if (question.id) {
        this.$set(question, 'willBeDeleted', !question.willBeDeleted);
      } else {
        let index = this.questions.indexOf(question);
        if (index >= 0) {
          this.questions.splice(index, 1);
        }
      }
    }
  },
  watch: {
    questions () {
      if (this.questions.length === 0) {
        this.addQuestion();
      }
      this.questions.forEach((question, i) => question.order = i);
    }
  }
}
</script>

<style>
</style>
